<template>
  <v-container>
    <v-layout row wrap>
      <v-card width="450" class="ma-3">
        <v-list-item>
          <v-list-item-avatar tile class="mt-n7">
            <v-sheet class="icon" color="green" width="80" height="80" elevation="10">
              <v-icon dark large>vertical_align_top</v-icon>
            </v-sheet>
          </v-list-item-avatar>
          <v-list-item-content>
            <div class="headline text-right">Publish</div>
            <div><v-divider></v-divider></div>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="topic"
                    label="Topic"
                    :rules="[(v) => !!v || 'Must provide a topic']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="value"
                    label="Value"
                    :rules="[(v) => !!v || 'Must provide a value']"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <v-btn color="success" class="mr-4" @click="create"> Publish </v-btn>
            <v-btn color="error" class="mr-4" @click="clear"> Clear </v-btn>
          </v-form>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script scoped>
import { connectMQTT } from "@/services/mqtt/configuration";
export default {
  data() {
    return {
      clientMQTT: connectMQTT(),
      topic: "",
      value: "",
    };
  },
  methods: {
    create() {
      this.$emit("createPublish", this.topic);
      this.clientMQTT.publish(this.topic, this.value);
    },
    clear() {
      (this.topic = ""), (this.value = "");
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 400px) {
  .icon {
    height: 20px;
    width: 20px;
  }
  .v-card {
    margin-top: 5px;
  }
  .v-col {
    margin-top: 5px;
  }
}
</style>
